/* eslint-disable */
import React, { useMemo, useEffect, useState } from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import StatCard from "../LayoutComponents/StatCard";

import FastAPIClient from "../../client";
import config from "../../config";
const client = new FastAPIClient(config);

type MeetingLog = {
    user_id: string;
    first_name: string;
    last_name: string;
    date: string;
    meeting_type: string;
    meeting_type_description: string;
    team_name: string;
    warehouse_name: string;
    meeting_count: number;
};

interface MeetingTypeChartProps {
    selectedUser: string;
    selectedTeam: string;
    selectedWarehouse: string;
    dateRange: [Dayjs | null, Dayjs | null];
}

const MeetingTypeChart: React.FC<MeetingTypeChartProps> = ({
    selectedUser,
    selectedTeam,
    selectedWarehouse,
    dateRange,
}) => {
    const [data, setData] = useState<MeetingLog[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchMeetings();
    }, [dateRange]);

    const fetchMeetings = async () => {
        try {
            setIsLoading(true);
            const response = await client.fetchUserMeetings();
            console.log("meetings", response.results);
            setData(response.results);
        } catch (error) {
            console.error("Error fetching meetings:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const filteredData = useMemo(() => {
        if (!data || !dateRange[0] || !dateRange[1]) return [];

        const [start, end] = dateRange;

        return data.filter((d) => {
            const inRange = dayjs(d.date).isBetween(start, end, null, "[]");
            const matchUser =
                selectedUser === "all" ||
                `${d.first_name} ${d.last_name}` === selectedUser;
            const matchTeam =
                selectedTeam === "all" || d.team_name === selectedTeam;
            const matchWarehouse =
                selectedWarehouse === "all" ||
                d.warehouse_name === selectedWarehouse;

            return inRange && matchUser && matchTeam && matchWarehouse;
        });
    }, [data, selectedUser, selectedTeam, selectedWarehouse, dateRange]);

    const chartData = useMemo(() => {
        const typeCounts: Record<string, number> = {};

        filteredData.forEach((entry) => {
            const type = entry.meeting_type_description || "Non spécifié";
            typeCounts[type] = (typeCounts[type] || 0) + (entry.meeting_count || 1);
        });

        // Sort types by count descending
        const sortedEntries = Object.entries(typeCounts).sort(
            (a, b) => b[1] - a[1]
        );

        const labels = sortedEntries.map(([label]) => label);
        const values = sortedEntries.map(([, value]) => value);

        return { labels, values };
    }, [filteredData]);

    if (isLoading) {
        return (
            <StatCard
                title="Réunions par type"
                value=""
                subtitle=""
                loading={true}
            />
        );
    }

    if (!data || chartData.labels.length === 0) {
        return (
            <StatCard
                title="Réunions par type"
                value=""
                subtitle="Aucune donnée disponible"
                loading={false}
            />
        );
    }

    return (
        <StatCard
            title="Réunions par type"
            value=""
            subtitle=""
            loading={false}
        >
            <BarChart
                layout="horizontal"
                yAxis={[
                    {
                        scaleType: "band",
                        data: chartData.labels,
                        label: "",
                        categoryGapRatio: 0.3,
                    },
                ]}
                series={[{ data: chartData.values }]}
                borderRadius={10}
                slotProps={{
                    legend: {
                        position: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                    },
                }}
                margin={{
                    left: 10,
                    bottom: 0,
                }}
                height={250}
                grid={{ vertical: false }}
                barLabel={(params) => `${params.value}`}
                sx={{
                    padding: "0px",
                    "& .MuiChartsAxis-left .MuiChartsAxis-line": {
                        display: "none",
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
                        fill: "#000000",
                        fontSize: 13,
                        fontFamily: "Roboto",
                        textAnchor: "start",
                        transform: "translateX(-40px)",
                    },
                    "& .MuiChartsAxis-left .MuiChartsAxis-tick": {
                        display: "none",
                    },
                    "& .MuiChartsAxis-bottom, & .MuiChartsAxis-bottom .MuiChartsAxis-line, & .MuiChartsAxis-bottom .MuiChartsAxis-tick, & .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel": {
                        display: "none",
                    },
                }}
            />
        </StatCard>
    );
};

export default MeetingTypeChart;
